import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { LOGIN_URL } from '../../client_url_constant'
import GoogleLoginButton from '../general/googleLoginButton2.png'

const grey = '#ffffff'
const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    fontSize: 12,
    textAlign:'center',
    backgroundColor: grey,
    zIndex:1,
  },
  input: {
    display: 'none',
  },
});
class LoginButton extends Component {
  render(){
  const { classes } = this.props;
  return (
    <div>
      <Button href={LOGIN_URL} className={classes.button}>
        <img alt={''} src={GoogleLoginButton}></img>
      </Button>
    </div>
  );
}
}


LoginButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginButton);



// WEBPACK FOOTER //
// ./src/components/Login/IntroLoginButton.js